<template>
  <section
    id="cta-contact"
    class="section"
    data-component="contact-cta"
  >
    <LazyBg :src="bgSrc" />
    <div class="container">
      <div class="cta-layout">
        <div class="cta-text reveal">
          <span class="card-tag">商务咨询</span>
          <h2 class="cta-title">开启数字化<br />转型之旅</h2>
          <p class="cta-desc">
            海曦技术提供ISO9001质量认证、IDC/ISP/CDN许可的全栈算力服务，系统可用性SLA达99.99%。留下您的信息，我们的专业团队将在24小时内与您对接，量身定制算力方案。
          </p>
        </div>

        <form class="contact-form reveal reveal-delay-2" @submit.prevent="onSubmit">
          <div class="form-row">
            <div class="form-field">
              <label for="home-name"><span class="req" aria-hidden="true">*</span>姓名:</label>
              <input id="home-name" v-model.trim="form.name" type="text" required autocomplete="name" />
            </div>
            <div class="form-field">
              <label for="home-company"><span class="req" aria-hidden="true">*</span>公司名称:</label>
              <input id="home-company" v-model.trim="form.company" type="text" required autocomplete="organization" />
            </div>
          </div>

          <div class="form-field form-field--full">
            <label for="home-email">邮箱:</label>
            <input id="home-email" v-model.trim="form.email" type="email" autocomplete="email" />
          </div>

          <div class="form-field form-field--full">
            <label for="home-message">需求描述:</label>
            <input id="home-message" v-model.trim="form.message" type="text" />
          </div>

          <button type="submit" class="form-submit" :disabled="submitting">
            {{ submitting ? '提交中…' : '提交咨询' }}
          </button>
        </form>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { reactive, ref } from 'vue';
import LazyBg from '@/components/LazyBg.vue';
import { fetchContactUsMessages } from '@/api/front';
import { useToast } from '@/composables/useToast';
import bgSrc from '@/assets/home_bg4.jpg';
import '@/styles/newhome/home/contact.css';

const { showToast } = useToast();
const form = reactive({ name: '', company: '', email: '', message: '' });
const submitting = ref(false);

async function onSubmit() {
  if (!form.name) {
    showToast('请填写姓名');
    return;
  }
  if (!form.company) {
    showToast('请填写公司名称');
    return;
  }

  submitting.value = true;
  try {
    await fetchContactUsMessages({
      contact: form.email || form.name,
      message: JSON.stringify({
        name: form.name,
        company: form.company,
        email: form.email,
        message: form.message,
        source: 'home-cta'
      })
    });
    showToast('感谢您的留言，我们会尽快回复！');
    form.name = '';
    form.company = '';
    form.email = '';
    form.message = '';
  } catch (e) {
    showToast(e instanceof Error ? e.message : '提交失败，请稍后重试');
  } finally {
    submitting.value = false;
  }
}
</script>
